import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import { PlugAvatar } from './PlugAvatar';
import { withBrandWord } from '../../components/primitives/BrandWord';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Outreach area; each part uses its own slice of it */
import styles from './Plug.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface PlugBarProps {
  title: string;
  sub?: string;
  /** Buttons or chips at the end of the bar. */
  children?: React.ReactNode;
  tone?: 'default' | 'bad';
  busy?: boolean;
  testId?: string;
}

/**
 * One line of agent status at the top of a page (design outreach p3, p6): the review queue, the
 * inbox, the autopilot sends and a failed job.
 */
const PlugBarComponent: React.FC<PlugBarProps> = ({ title, sub, children, tone = 'default', busy = false, testId }) => (
  <div className={clsx(styles.bar, tone === 'bad' && styles.barBad)} data-testid={testId ?? 'plug-bar'} role="status">
    <PlugAvatar size={40} state={tone === 'bad' ? 'error' : busy ? 'busy' : 'idle'} />
    <div className={styles.barText}>
      <b>{withBrandWord(title)}</b>
      {sub !== undefined && <small>{withBrandWord(sub)}</small>}
    </div>
    {children}
  </div>
);

export const PlugBar = TypedMemo(PlugBarComponent);
